<template lang="pug">
  div(class="list curriculum-list media-list")
    ul
      curriculum-list-item(
        v-for="curriculum in curriculums"
        :key="curriculum.id"
        :curriculum="curriculum"
        @click="$emit('click', curriculum.id)")
</template>

<style lang="scss" scoped>
.curriculum-list {
  margin: 0;
}
</style>

<script>
import CurriculumListItem from '@/components/molecules/CurriculumListItem'

export default {
  components: {
    CurriculumListItem,
  },
  props: {
    curriculums: {
      type: Array,
      required: true,
    },
  },
}
</script>
